import { useQuery } from '@tanstack/react-query'
import { Stack, Typography } from '@mui/material'
import { fetchMe, ME_QUERY_KEY, nomeParaTela } from '../api/session'
import { visibleNavItems } from '../components/navItems'
import { t } from '../i18n'

/**
 * B1 (sessao 35) - pagina inicial DENTRO da casca. Substitui a pagina de estado
 * do B0 (build, API, telemetria), que era de conferencia tecnica.
 *
 * Sem modulo liberado, diz isso em vez de mostrar um menu vazio sem explicacao.
 */
export function HomePage() {
  const me = useQuery({ queryKey: ME_QUERY_KEY, queryFn: fetchMe })
  const modules = visibleNavItems(me.data?.permissions ?? []).filter((i) => i.to !== '/')

  return (
    <Stack spacing={1}>
      <Typography variant="h1" component="h1">
        {t.home.greeting}
        {me.data?.user ? `, ${nomeParaTela(me.data.user.username)}` : ''}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {modules.length > 0 ? t.home.subtitle : t.home.noModules}
      </Typography>
    </Stack>
  )
}
